<template>
<div class="page-content" data-test-key="token-page">
  <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
    <div class="container mx-auto">
        <div class="grid">
            <div class="col-span-12">
                <div class="text-center text-white">
                    <h3 class="mb-4 text-[26px]">Redeem Token</h3>
                    <!-- <div class="page-next">
                      <p>If you've got a question, a comment, a proposal or anything else, we'd love to hear from you!</p>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
    <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
  </section>

  <section class="pt-16 py-20">
    <div class="container mx-auto">
      <div class="grid items-center grid-cols-12 mt-5 lg:gap-8 gap-y-8">
        <div class="col-span-12 lg:col-span-12">
          <!-- <h1>Token {{ this.token }}</h1> -->
          <FeedbackNotification v-if="this.notification.text != ''" 
          :feedbackText="this.notification.text" 
          :feedbackLevel="this.notification.level"/>
          <div v-else>
          <div v-if="showProcessCompanyUserInviteForm">
            <CompanyProcessUserInviteForm @formsubmitted="formSubmittedEventHandler(e)" />
          </div>
          <div v-if="showProcessResetPasswordForm">
             <CompanyPasswordResetInputForm @formsubmitted="formSubmittedEventHandler(e)" />
          </div>
          <div v-if="showProcessCompanyDeleteForm">
             are you sure you want to delete?
          <button v-on:click="processCompanyDeleteHandler">Delete Company</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>

</template>

<script>
import { companyAPI } from "@/api/company";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import { mapGetters } from "vuex"; 

const pageStatus = useStatus();
const log = useErrorLogger();

import CompanyPasswordResetInputForm from "@/components/Forms/CompanyPasswordResetInputForm.vue";
import CompanyProcessUserInviteForm from "@/components/Forms/CompanyProcessUserInviteForm.vue";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import { emailSubscriptionAPI } from "@/api/emailSubscription";

export default {  
  name: "CompanyLoginView",
  components : {
    CompanyPasswordResetInputForm, CompanyProcessUserInviteForm, FeedbackNotification
  }, 
  data() 
  {
    return {
      notification : {
        text : "",
        level : "",
      },
      token : this.$route.params.token,
      tokenType : this.$route.params.tokentype,
      showProcessCompanyUserInviteForm : false,
      showProcessResetPasswordForm : false,
      showProcessCompanyDeleteForm : false,
    };                  
  },
 created() {
    if (this.companyUserStore != null)
    {
      this.$router.push('/')        
    }
    else 
    {
      // check token is a guid
      switch(this.tokenType)
      {
        case "er":
           this.processEmailSubscriptionRedeemHandler();
            return;
        // case "pcec":
        //     this.processCompanyEmailConfirmationHandler();
        //     return;
        // case "pcui":
        //     this.showProcessCompanyUserInviteForm = true;
        //     return;
        // case "pcurp":
        //     this.showProcessResetPasswordForm = true;
        //     return;
        // case "pcd":
        //     this.showProcessCompanyDeleteForm = true;
        //     return;
        default:
            this.notification = { text : "Unable to define the correct token link", level : "notification" };        
            return;
      }    
    }
 },
  mounted() {
    document.title = 'Token - TheJobTap.com'
  },
 computed :{
    ...mapGetters(['companyUserStore'])
 },
  methods: {
  async formSubmittedEventHandler(value){

  },
  async processEmailSubscriptionRedeemHandler(){
    const result = await log.catchPromise(() =>
      pageStatus.observe(async () => {
        const result = await emailSubscriptionAPI.redeem(this.token);
        console.log(result)
        if(result.data)
        {
          this.notification = { text : "Processed Email Subsctipion", level : "success" };        
        }
      })
    );
    if (!result.success) 
    {
        this.notification = { text : 'Unable to process Email Subsctipion' + " [" + result.data + "]", level : "error" };        
    }  
  },
  async processCompanyDeleteHandler(){
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await companyAPI.processDelete(this.token);
          console.log(result)
          if(result.data)
          {
            this.notification = { text : "Processed Company Delete", level : "success" };        
          }
        })
      );
      if (!result.success) {
          this.notification = { text : 'Unable to process Company Delete' + " [" + result.data + "]", level : "error" };        
      }
  },
  async processCompanyEmailConfirmationHandler(){
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await companyAPI.processEmailConfirmation(this.token);
          console.log(result)
          if(result.data)
          {
            this.notification = { text : "Processed Company Email Confirmation", level : "success" };        
          }
        })
      );
      if (!result.success) {
          this.notification = { text : 'Unable to process Company Email Confirmation' + " [" + result.data + "]", level : "error" };        
      }
   },
 }
};
</script>
